module.exports = __webpack_public_path__ + "img/coin_brown.e32b20b4.svg";